import classnames from '../../node_modules/classnames/index.js';
import { forwardRef, createElement } from 'react';
import useiOSActiveState from './useiOSActiveState.js';
import { highlightText } from '../util/highlight.js';
import styles from '../styles/ListItem.module.scss';
import Toggle from './Toggle.js';

/**
 * Internal component that contains the item-specific logic
 * for the List component.
 */
var ListItem = function (_a, ref) {
    var _b;
    var description = _a.description, disabled = _a.disabled, highlightDescription = _a.highlightDescription, highlightText$1 = _a.highlightText, icon = _a.icon, noBorder = _a.noBorder, onClick = _a.onClick, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, selected = _a.selected, selectedStyle = _a.selectedStyle, tabIndex = _a.tabIndex, text = _a.text, textEl = _a.textEl, _c = _a.wrapText, wrapText = _c === void 0 ? "description" : _c;
    var handleClick = function (e) {
        if (!disabled) {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }
    };
    var handleFocus = function (e) {
        if (!disabled) {
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        }
    };
    var handleKeyDown = function (e) {
        if (!disabled) {
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
        }
    };
    var handleKeyUp = function (e) {
        if (!disabled) {
            onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(e);
        }
    };
    var handleMouseDown = function (e) {
        // Do not focus disabled elements.
        if (disabled) {
            e.preventDefault();
        }
    };
    var handleTouchStart = useiOSActiveState(undefined);
    var wrapDescription = wrapText !== "inline" && wrapText !== "none";
    var wrapTitle = wrapText === "both" || wrapText === true;
    // Error as designs are not available for this case.
    if (icon && description && selectedStyle === "checkbox") {
        throw Error("A ListItem with a checkbox may not have both an icon and a description.");
    }
    return (createElement("li", { "aria-disabled": disabled === true, "aria-selected": selected, className: classnames(styles.item, (_b = {},
            _b[styles.borderless] = noBorder,
            _b[styles.disabled] = disabled,
            _b[styles["has-checkbox"]] = selectedStyle === "checkbox",
            _b[styles["has-description"]] = description,
            _b[styles["has-icon"]] = icon,
            _b[styles["has-scale"]] = selectedStyle === "scale",
            _b[styles.selected] = selected,
            _b)), onClick: handleClick, onFocus: handleFocus, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, onMouseDown: handleMouseDown, onTouchStart: handleTouchStart, ref: ref, role: "option", tabIndex: tabIndex, title: text },
        createElement("div", { className: styles.inner },
            icon ? createElement("div", { className: styles["icon-container"] }, icon) : null,
            createElement("div", { className: styles["text-container" + (wrapText === "inline" ? "-inline" : "")] }, textEl !== null && textEl !== void 0 ? textEl : (createElement("div", { className: styles["text" + (wrapTitle ? "-wrap" : "")], dangerouslySetInnerHTML: {
                    __html: highlightText(text, highlightText$1 !== null && highlightText$1 !== void 0 ? highlightText$1 : [], "strong"),
                } })),
                description ? (createElement("div", { className: styles["description" + (wrapDescription ? "-wrap" : "")], dangerouslySetInnerHTML: {
                        __html: highlightText(description, highlightDescription !== null && highlightDescription !== void 0 ? highlightDescription : [], "strong"),
                    } })) : null),
            selectedStyle === "checkbox" ? (createElement(Toggle, { checked: selected, disabled: disabled, onChange: function () {
                    // The list item manually handles keyboard and mouse events
                    // so we don't need to do anything here. We should still add
                    // the handler so that React renders a controlled component.
                }, tabIndex: -1, type: "checkbox" })) : null),
        selected && selectedStyle === "scale" ? (createElement("svg", { className: styles["scale-checkmark"], viewBox: "0 0 24 24" },
            createElement("path", { className: styles["scale-checkmark-background"], clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fillRule: "evenodd" }),
            createElement("path", { className: styles["scale-checkmark-icon"], clipRule: "evenodd", d: "M10.9183 13.3536L8.54733 11.0366C7.8882 10.3925 6.83158 10.3971 6.17695 11.0368C5.51776 11.681 5.52223 12.7136 6.17672 13.3532L9.73309 16.8286C10.3922 17.4728 11.4488 17.4681 12.1035 16.8284C12.1697 16.7637 12.2291 16.6952 12.282 16.6234C12.3559 16.5714 12.4266 16.5129 12.4932 16.4478L19.0838 10.0072C19.741 9.365 19.7448 8.32409 19.0902 7.68436C18.431 7.04018 17.3714 7.04743 16.7132 7.69059L10.9183 13.3536Z", fillRule: "evenodd" }))) : null));
};
var ListItemComponent = forwardRef(ListItem);

export default ListItemComponent;
